import Main from "./components/Main/Main";
import styles from "./styles.module.css";

import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme/theme";
import { DownloadAppBottomSheet } from "./components/DownloadAppBottomSheet/DownloadAppBottomSheet";

export default function Layout() {
  return (
    <ThemeProvider theme={theme}>
      <div className={styles.layout}>
        <Main />
        <DownloadAppBottomSheet />
      </div>
    </ThemeProvider>
  );
}
